import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LayoutContainer = styled(Box)(() => ({
	display: 'flex',
	minHeight: '100dvh',
}));

export const MainContent = styled(Box)(() => ({
	width: '100%',
}));

